import { Typography } from '@/components/ui/typography';

export const TermsInfo = () => (
  <Typography as="p" variant="body" className="text-left">
    By continuing, you agree to our{' '}
    <a
      target="_blank"
      href="https://www.planomatic.com/privacy-policy/"
      className="font-semibold underline"
      rel="noreferrer"
    >
      Privacy &amp; Cookie Policy
    </a>{' '}
    and{' '}
    <a
      target="_blank"
      href="https://www.planomatic.com/terms-and-conditions/"
      className="font-semibold underline"
      rel="noreferrer"
    >
      Terms &amp; Conditions
    </a>
  </Typography>
);
